import { fetchWrapper } from "@/helpers";

const ruta = process.env.VUE_APP_ROOT_API;

export default class PosService {
  async getCatalogo(parametros) {
    const queryParams = parametros
      ? Object.keys(parametros)
          .map(
            (k) =>
              encodeURIComponent(k) + "=" + encodeURIComponent(parametros[k])
          )
          .join("&")
      : "";
    // Usamos el endpoint específico para el POS definido en el backend
    return await fetchWrapper.get(`${ruta}/pos/catalogo?` + queryParams);
  }

  async procesarVenta(datos) {
    // Endpoint 3: Procesamiento de Venta (Checkout)
    return await fetchWrapper.post(`${ruta}/pos/ventas/procesar`, datos);
  }

  /**
   * Actualizar stock en tiempo real (polling)
   */
  async actualizarStock(productosIds, paquetesIds, sucursalId){
      //  Enviar como array (no como string)
    const params = new URLSearchParams();
    
    // Agregar cada ID como parámetro separado
    productosIds.forEach(id => {
        params.append('productos_ids[]', id);
    });
    paquetesIds.forEach(id => {
        params.append('paquetes_ids[]', id);
    });
    params.append('sucursal_id', sucursalId);
      return await fetchWrapper.get(`${ruta}/pos/stock/actualizar?${params.toString()}`);      
  }

  /**
  * Verificar stock de un producto
  */
  async verificarStock(item, sucursalId, cantidad = 1) {
    const params = new URLSearchParams({
      sucursal_id: sucursalId,
      cantidad: cantidad
    });
    
    if (item.es_paquete) {
      params.append('paquete_id', item.id);
    } else {
      params.append('producto_id', item.id);
    }
    
    return await fetchWrapper.get(`${ruta}/pos/stock/verificar?${params.toString()}`);
  }

  
}
